import Cookies from 'universal-cookie'

const cookies = new Cookies()

export function useAuth() {
  if (cookies.get('TOKEN_NSL') || sessionStorage.getItem('TOKEN_NSL')) {
    return true
  }
  return false
}

export function setAuth(prop, val, session = false) {
  if (session) {
    cookies.set(prop, val, { path: '/', maxAge: 7948800 })
  } else {
    sessionStorage.setItem(prop, val)
  }
}

export function getToken() {
  return cookies.get('TOKEN_NSL') || sessionStorage.getItem('TOKEN_NSL')
}
export function getAccountID() {
  return cookies.get('AUTH_NSL') || sessionStorage.getItem('AUTH_NSL')
}
export function getUserId() {
  return cookies.get('USER_ID') || sessionStorage.getItem('USER_ID')
}
